const campaignStatus = Object.freeze({
  current: 0,
  finished: 1,
});

export default campaignStatus;
